import Divider from 'components/Divider';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import React, { useMemo } from 'react';
import { CopyOutline } from 'react-ionicons';
import { useQuery } from 'react-query';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { copyText, getKeys } from './utils';
import Loader from 'components/Loader';
import Layout from './Layout';

const ApiKey = () => {
  const { client_id } = useParams<{ client_id: string }>();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery(
    ['user-settings-api-key', client_id],
    async () => {
      const response = await getKeys({});
      const matchedKey = response.data.find(
        (item) => item.client_id === client_id,
      );
      if (!matchedKey) throw new Error('Key not found');
      return matchedKey;
    },
    {
      refetchOnMount: true,
    },
  );

  const breadcrumbs = useMemo(
    () => [
      {
        icon: 'home',
        label: 'Integrations',
        onClick: () => navigate('/integrations'),
      },
      {
        label: data?.label ?? '',
      },
    ],
    [navigate, data],
  );

  const onDelete = () => navigate(`delete/${data?.label}`, { replace: true });
  const onRegenerate = () =>
    navigate(`regenerate/${data?.label}`, { replace: true });

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Outlet />
      <p className="mb-6 text-2xl font-bold text-content-base-default">
        Key details
      </p>
      {isLoading ? (
        <Loader className="h-full w-full" />
      ) : (
        <>
          <div>
            <p className="font-bold">Key name</p>
            <p className="font-bold text-content-base-default">{data?.label}</p>
          </div>
          <div className="mt-4">
            <p className="font-bold">Client key</p>
            <p className="flex gap-2">
              <span className="font-bold text-content-base-default">
                {data?.client_id}
              </span>
              <span
                className="cursor-pointer hover:text-content-accent-default"
                onClick={(e) => {
                  e.stopPropagation();
                  copyText(
                    'API client key copied to clipboard!',
                    data!.client_id,
                    data!.label,
                  );
                }}
              >
                <CopyOutline width="24px" height="24px" color="currentColor" />
              </span>
            </p>
          </div>
          <Divider className="my-16" />
          <div className="flex gap-4">
            <GraniteButton
              variant="secondary"
              size="large"
              onClick={onRegenerate}
            >
              Regenerate key
            </GraniteButton>
            <GraniteButton
              variant="destructive"
              size="large"
              onClick={onDelete}
            >
              Delete key
            </GraniteButton>
          </div>
        </>
      )}
    </Layout>
  );
};

export default ApiKey;
